"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fgLoadcss = require("fg-loadcss");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("@material-ui/styles");

var _ = require("./");

var _styledComponents = require("styled-components");

var _themeContext = _interopRequireDefault(require("./theme-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var nextTheme = Object.assign({}, theme);

  _react["default"].useEffect(function () {
    (0, _.checkForDom)() && (0, _fgLoadcss.loadCSS)('https://use.fontawesome.com/releases/v5.1.0/css/all.css', document.querySelector('#font-awesome-css'));
  }, []);

  return _react["default"].createElement(_styles2.StylesProvider, {
    injectFirst: true
  }, _react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: nextTheme
  }, _react["default"].createElement(_styles.MuiThemeProvider, {
    theme: nextTheme
  }, _react["default"].createElement(_CssBaseline["default"], null), _react["default"].createElement(_themeContext["default"].Provider, {
    value: nextTheme
  }, children))));
};

ThemeProvider.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
  theme: _propTypes["default"].object.isRequired
};
var _default = ThemeProvider;
exports["default"] = _default;